import React from 'react';
import MaterialLinearProgress from '@mui/material/LinearProgress';
import type {LinearProgressProps as MaterialProgressProps} from '@mui/material/LinearProgress';
import {styled} from '@mui/material/styles';
import {FuelSize, getFuelSize} from '../types/general';

type FuelVariants = 'buffer' | 'indeterminate' | 'determinate';

export interface LinearProgressProps extends Omit<MaterialProgressProps, 'variant' | 'color'> {
    variant?: FuelVariants;
    size?: FuelSize;
}

const StyledLinearProgress = styled(MaterialLinearProgress)<LinearProgressProps>(({size: currentSize}) => {
    const size = getFuelSize(currentSize);

    return {
        ...size === 'small' && {
            height: '0.125rem'
        },
        ...size === 'medium' && {
            height: '0.25rem'
        },
        ...size === 'large' && {
            height: '0.5rem'
        }
    };
});

export const LinearProgress = React.forwardRef<any, LinearProgressProps>(
    ({
        size = 'medium', variant = 'indeterminate', ...props
    }, ref) => {
        return (
            <StyledLinearProgress
                color='primary'
                ref={ref}
                size={size}
                variant={variant}
                {...props}
            />
        );
    }
);

LinearProgress.displayName = 'LinearProgress';
